
import {
    ProviderRevenueList,
  } from "../apiHelpers/revenue/list";
export const ProviderRevenueListAction = (params) => async dispatch => {
    try {
        const apiData = await ProviderRevenueList(params);
      return ({error: false,message:'success', data : apiData.data || []});
    } catch (e) {
        return ({error: true, data : [], message:  e.message || 'Something went wrong.Please try later.'});
    }
  };


// WEBPACK FOOTER //
// ./src/actions/Revenue.js